import { ReactComponent as DeleteIcon } from "../../../assets/icons/delete-icon-new.svg";
import { ReactComponent as GalleryIcon } from "../../../assets/icons/gallery-icon.svg";
import UBArrowInput from "../../../Libraries/UBArrowInput";
import LineText from "../../../Libraries/LineText";
import UBInput from "../../../Libraries/UBInput";
import React, { useState } from "react";
import "./styles.css";
import {
  CREATED_VARIANT_FIELDS,
  handleNumerInput,
  getVariantName,
} from "../../../constants/variantConstants";
import styles from "./styles.module.css";
import { analytics, triggerLogEvent } from "../../../config/firebase";

const CreatedVariant = ({
  handleDeleteVariant = () => { },
  handleUpdateVariantField,
  hideDeleteIcon = false,
  variantData,
  onImgAdd,
  showError,
  ind = 0,
  readOnly = false
}) => {

  const [quantity, setQuantity] = useState(variantData?.[CREATED_VARIANT_FIELDS.STOCK_QUANTITY] ?? "");
  const [moq, setMoq] = useState(variantData?.[CREATED_VARIANT_FIELDS.MINIMUM_ORDER_QUANTITY] ?? "");
  const [price, setPrice] = useState(variantData?.[CREATED_VARIANT_FIELDS.SALE_PRICE] || "");
  const [weight, setWeight] = useState(variantData?.[CREATED_VARIANT_FIELDS.WEIGHT] || "");

  React.useEffect(() => {
    setMoq(variantData?.[CREATED_VARIANT_FIELDS.MINIMUM_ORDER_QUANTITY] ?? "");
    setPrice(variantData?.[CREATED_VARIANT_FIELDS.SALE_PRICE] || "");
    setQuantity(variantData?.[CREATED_VARIANT_FIELDS.STOCK_QUANTITY] ?? "");
    setWeight(variantData?.[CREATED_VARIANT_FIELDS.WEIGHT] || "");

    return () => { };
  }, [variantData]);

  return (
    <div className={`d-flex align-items-center`}>
      <div
        className={`variantTable p-2  ${showError ? "err_variant_state" : ""}`}
      >
        <div className='col-variants'>
          <div className='img-holder bg-white' role='button' onClick={() => { if (!readOnly) { triggerLogEvent(analytics, "sb_variant_edit", { index: ind }); onImgAdd(); } }}>
            {variantData?.[CREATED_VARIANT_FIELDS.IMAGES] ? (
              <img
                src={variantData?.[CREATED_VARIANT_FIELDS.IMAGES]?.[0]?.image}
              />
            ) : (
              <GalleryIcon height={20} width={20} />
            )}
          </div>
          <LineText className='fontSize14'>
            {getVariantName(variantData?.attributes)}
          </LineText>
        </div>
        <UBInput
          inputId="variant_name_input"
          readOnly={readOnly}
          placeholder='Weight (gm)'
          className='created-variant-inp bg-white'
          baseClassname={styles.VariantInput}
          suffix={weight ? "(gm)" : ""}
          value={weight}
          onChange={(key, value) => {
            handleNumerInput(value, () => {
              setWeight(value);
              handleUpdateVariantField(
                ind,
                value,
                CREATED_VARIANT_FIELDS.WEIGHT
              );
            });
          }}
          maxLength={6}
        />
        <UBInput
          inputId="variant_price_input"
          readOnly={readOnly}
          baseClassname={styles.VariantInput}
          placeholder='Rs. 0'
          className='created-variant-inp bg-white'
          prefix={price ? "Rs. " : ""}
          value={price}
          onChange={(key, value) => {
            handleNumerInput(value, () => {
              setPrice(value);
              handleUpdateVariantField(
                ind,
                value,
                CREATED_VARIANT_FIELDS.SALE_PRICE
              );
            });
          }}
          maxLength={7}
        />
        <UBArrowInput
          readOnly={readOnly}
          id={`min-qty-inp-${ind}`}
          min={1}
          max={999999}
          placeholder={"0"}
          value={moq}
          setValue={(value) => {
            setMoq(Number(value));
            handleUpdateVariantField(
              ind,
              Number(value),
              CREATED_VARIANT_FIELDS.MINIMUM_ORDER_QUANTITY
            );
          }}
        />
        <UBArrowInput
          readOnly={readOnly}
          id={`avlbl-qty-inp-${ind}`}
          min={0}
          max={999999}
          placeholder={"0"}
          value={quantity}
          setValue={(value) => {
            setQuantity(Number(value));
            handleUpdateVariantField(
              ind,
              Number(value),
              CREATED_VARIANT_FIELDS.STOCK_QUANTITY
            );
          }}
        />
      </div>
      {!hideDeleteIcon ? (
        <DeleteIcon
          className='ms-2'
          role='button'
          onClick={() => { triggerLogEvent(analytics, "sb_variant_delete", { index: ind }); handleDeleteVariant(ind); }}
        />
      ) : (
        <></>
      )}
    </div>
  );
};

export default CreatedVariant;
